import { OAUTH_STATUS_REDUCER_KEY } from 'store/oauthStatus/actions'
import { OAuthStatusState } from 'store/oauthStatus/interfaces'

export const oauthStatusSelector = (state: { [OAUTH_STATUS_REDUCER_KEY]: OAuthStatusState }) =>
  state[OAUTH_STATUS_REDUCER_KEY]
